/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPeace = createReactComponent("outline", "peace", "IconPeace", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 18", "key": "svg-1" }], ["path", { "d": "M12 12l6.3 6.3", "key": "svg-2" }], ["path", { "d": "M12 12l-6.3 6.3", "key": "svg-3" }]]);

export { IconPeace as default };
//# sourceMappingURL=IconPeace.mjs.map
